<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                    <el-form-item label="仓库:">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						>
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户:">
						<el-select filterable v-model="searchInfo.customerId"  placeholder="请选择" clear 
                        style="width: 220px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item>
                    <!-- <el-form-item label="状态:">
						<el-select filterable v-model="searchInfo.status"  placeholder="请选择" clear 
                        style="width: 120px">
							<el-option  :key="0" :value="0" label="制单中"></el-option>
							<el-option  :key="1" :value="1" label="移库中"></el-option>
							<el-option  :key="2" :value="2" label="已完成"></el-option>
						</el-select>
					</el-form-item> -->
                    <!-- <el-form-item label="移库单号:" >
						<el-input type="text" style="width: 220px; " placeholder="请输入出库单号"  v-model="searchInfo.orderCode"
							auto-complete="off" />
					</el-form-item> -->
                   
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="addCarousel">新增</el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" border="">
			<!-- <el-table-column type="index" align="center" width="90" label="#">
			</el-table-column> -->
			
			<el-table-column prop="warehouseName" label="仓库" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="customerName" label="客户名称" align="center" width="200" >
			</el-table-column>
			 <el-table-column prop="pdtCode" label="商品编码" align="center" width="200" >
			</el-table-column>
			<el-table-column prop="pdtName" label="商品名称" align="center" width="200" >
			</el-table-column>
			<el-table-column prop="warehouseLocationFromName" label="源库位" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="warehouseLocationToName" label="目标库位" align="center" width="150" :show-overflow-tooltip="true">
			</el-table-column>
		    <el-table-column prop="goodsStatusFormName" label="状态(转换前)" align="center" width="110" :show-overflow-tooltip="true">
		    </el-table-column>
			<el-table-column prop="goodsStatusToName" label="状态(转换后)" align="center" width="110" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="num" label="变动数"  align="center" width="120" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="eaNum" label="变动数EA"  align="center" width="120" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="batchNo" label="批次号"  align="center" width="120" :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="storageTime" label="入库日期" align="center"  width="120"  :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="memo" label="备注" align="center" width="120"  :show-overflow-tooltip="true">
			</el-table-column>
            <el-table-column prop="createBy" label="操作人"  align="center"  width="120"  :formatter="changeNull">
			</el-table-column>
			<el-table-column prop="updateBy" label="修改人"  align="center"  width="120"  :formatter="changeNull">
			</el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center" width="180"  :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="修改时间" align="center" width="180"  :show-overflow-tooltip="true">
			</el-table-column>

			<!-- <el-table-column fixed="right" label="操作" align="center" :show-overflow-tooltip="true" width="150px">
				<template slot-scope="scope">
					<el-button size="small" type="text" v-if="scope.row.status!=2" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" 
					@click="editialogVisible(scope.row.id)" v-if="scope.row.status==2">查看</el-button>

					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>

				</template>
			</el-table-column> -->
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 新增、编辑 -->
		<el-dialog :visible.sync="dialogVisibleSwiper" :title="poupTitle+''" @close="addDialogClose" center
			:close-on-click-modal="false" width="900px">
			<div style="text-align: center">
				<el-form v-model="storeGoodsInfo">
					<div style="display: flex;">
						<el-form-item label-width="120px"  label="仓库名称:">
							<el-select filterable v-model="storeGoodsInfo.warehouseId" style="width: 300px" placeholder="请选择" clear 
							@change="warehouseChange">
								<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="客户:" label-width="120px" >
							<el-select filterable v-model="storeGoodsInfo.customerId" placeholder="请选择" clear value-key="id"
							style="width: 300px">
								<el-option v-for="it in poupUserList" :key="it.customerId" :value="it.customerId"
									:label="it.customerName"></el-option>
							</el-select>
							<!-- @change="customerSelect" -->
						</el-form-item>
					</div>
					<div style="border: 1px solid lightgrey;padding: 10px;">
					<el-form-item label="商品:" >
						<el-select  :remote-method="goodsInput"  style="width: 790px" 
							filterable  v-model="storeGoodsInfo.pdtCode" 
							remote @change="goodChange"
							allow-create
							clearable
							placeholder="请搜索选择" >
							<div style="display: flex;padding: 0 20px;font-size: 14px;">
								<span style="width:150px;display: inline-block;">商品编号</span>
								<span style="width:120px;display: inline-block;">源库位</span>
								<span style="width:80px;display: inline-block;">商品状态</span>
								<span style="width:120px;display: inline-block;">批次</span>
								<span style="width:80px;display: inline-block;">库存</span>
								<span style="width:80px;display: inline-block;">库存EA</span>
								<span style="padding-left:30px;display: inline-block;">商品名称</span>
							</div>
							<el-option v-for="(item,index) in goodsDataList" :key="index" :value="item.id"
							:label="item.pdtCode+'---'+item.warehouseLocationName+'---'+item.goodsStatusName+'---'+item.batchNo+'---'+item.pdtName" 
							>
								<span style="width:150px; color: #8492a6;display: inline-block;">{{ item.pdtCode }}</span>
								<span style="width:120px; color: #20A0FF; display: inline-block;">{{ item.warehouseLocationName }}</span>
								<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.goodsStatusName }}</span>
								<span style="width:120px; color: #20A0FF; display: inline-block;">{{ item.batchNo }}</span>
								<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.num }}</span>
								<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.eaNum }}</span>
								<span style="padding-left:30px;display: inline-block;">{{ item.pdtName }}</span>
							</el-option>
						</el-select>
						<!-- {{storeGoodsInfo.pdtName}} -->
					</el-form-item>
					<el-form-item label="商品名称:"  style="margin-bottom:0px;">
							<span>{{ storeGoodsInfo.pdtName }}</span>
						</el-form-item>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="源库位:" >
								<span>{{ storeGoodsInfo.warehouseLocationFromName }}</span>
							</el-form-item>
							<el-form-item label="状态(转换前):" >
								<span>{{ storeGoodsInfo.goodsStatusFormName }}</span>
							</el-form-item>
							<el-form-item label="批次:" >
								<span>{{ storeGoodsInfo.batchNo }}</span>
							</el-form-item>
							<el-form-item label="库存:" >
								<span>{{ storeGoodsInfo.numOne }}</span>
							</el-form-item>
							<el-form-item label="库存EA:" >
								<span>{{ storeGoodsInfo.eaNumOne }}</span>
							</el-form-item>
						</div>
					</div>
					<div style="height:20px;"></div>
					<div style="display: flex;">
						<el-form-item label="目标商品状态:" label-width="120px">
							<el-select filterable clearable v-model="storeGoodsInfo.goodsStatusTo" placeholder="请选择" style="width: 300px">
								<el-option v-for="it in stateOfGoodsList" :key="it.id" :value="it.typeKey" :label="it.typeName"  ></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item label="目标库位:" label-width="120px">
							<el-select filterable clearable v-model="storeGoodsInfo.warehouseLocationTo"
								placeholder="请选择"  style="width: 300px">
								<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.warehouseLocationName" ></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;">
						<el-form-item label="变动数:"  label-width="120px">
							<el-input @input="inputInputRight('num')" type="number" v-model="storeGoodsInfo.num" placeholder="请输入变动数" clearable style="width: 300px" ></el-input>
						</el-form-item>
						<el-form-item label="变动数EA:"  label-width="120px">
							<el-input @input="inputInputRight('eaNum')" type="number" v-model="storeGoodsInfo.eaNum" placeholder="请输入变动数EA" clearable style="width: 300px" ></el-input>
						</el-form-item>
					</div>
                    <el-form-item label="备注:" label-width="120px">
						<el-input type="text" style="width: 720px;" v-model="storeGoodsInfo.memo" auto-complete="off" placeholder="请输入备注" />
					</el-form-item>
                    <div style="height:50px"></div>
					<el-button type="primary" @click="submit" v-if="poupTitle=='新增'" :loading="addLoading">提交</el-button>
					<el-button type="primary" @click="submitClick" v-if="poupTitle=='编辑'" :loading="editLoading">提交</el-button>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					num: '',
					eaNum: ''
				},
				dialogVisibleSwiper: false,
                // dialogVisibleSwipers: false
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                warehouseList: [],
				userList: [],
				
				poupUserList: [],
				goodsDataList: [],
				locationList: [],
				stateOfGoodsList: [], //货物状态

				boxGauge: 1,
			}
		},
		methods: {
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()

			},
			empty() { //清空
				this.searchInfo = {}

			},
			addDialogClose() {
				this.storeGoodsInfo = {}
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					warehouseId: this.searchInfo.warehouseId, //仓库
					// orderType: this.searchInfo.orderType, //类型
					customerId: this.searchInfo.customerId, //客户
					// status: this.searchInfo.status, //订单状态
					// customerOrderCode: this.searchInfo.customerOrderCode, //客户订单号
					// orderCode: this.searchInfo.orderCode, //移库单号
					// orderSource: this.searchInfo.orderSource, //来源单号
				}
				this.$api.getGoodsTransStatusList(data).then((res) => {
					// console.log('转换---',res.data)
					if (res.state == 'success') {
						this.expressList = res.data.list
						this.sliderlist = res.data
					}
				})

			},
			// 新增
			addCarousel() {
				this.storeGoodsInfo = {};
				this.warehouseId = '';
                this.poupTitle = '新增';
                this.dialogVisibleSwiper = true;

                // let url='/warehouseBill/addorder'
				// this.$api.findByManageUserIdManageFunction().then((res) => {
				// 	if (res.state == 'success') {
				// 		res.data.forEach(item => {
				// 		    item.manageFunctionList.forEach(i => {
				// 		        if (i.routePath === url) {
				// 		          this.next(i,'1')
				// 		        }
				// 		    });
				// 		});
				// 	}
				// })
			},
            next(item,i,id) {
				if (this.$route.path != item.routePath) {
					if(i==1){
						this.$router.push(item.routePath)
					}else{
						this.$router.push({
							path:item.routePath,
							query:{
												     
                                    id:id,
								}
							})
					}
				}
				if(JSON.stringify(this.$store.state.openTab).includes(item.routePath)){
					this.$store.commit('setactiveindex',item.routePath)
				}else{
					this.$store.commit('addtabs',item)
					this.$store.commit('setactiveindex',item.routePath)
						
				}
			},
			warehouseChange(e){ //仓库选择
				// this.warehouseChangeNum++;
				//获取该仓库的全部库位
				this.$api.getLocationListNoParameter({
                    warehouseLocationName: '',
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
				this.$api.getClientListByWarehouse({
					warehouseId: e
				}).then(res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('客户数据--', res.data)
					this.poupUserList = res.data
				})
			},
			goodsInput(e) {
				if(this.storeGoodsInfo.warehouseId || this.storeGoodsInfo.customerId){}else{
					this.$message.error('请先选择仓库和客户');
					return
				}
				this.goodsDataList=[] 
				let data = {
					queryParam: e,
					warehouseId: this.storeGoodsInfo.warehouseId,
					customerId: this.storeGoodsInfo.customerId
				}
				// console.log('参数---', data)
				// this.$encrypt()
				this.$api.getGoodsListByWarehouseAndClient(data).then(res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('商品---', res.data)
					if (res.data.length > 0) {
						this.goodsDataList = res.data;
					} else {
						this.goodsDataList = []
					}
				})
			},
			goodChange(e){
				// console.log('22333')
				// this.ids = e;
				let obj = {};
				// console.log('商品--', this.goodsDataList)
				// console.log('选择的--', e)
				obj = this.goodsDataList.find((item) => { //这里上面遍历的数据源
					return item.id == e; //筛选出匹配数据
				});
				// console.log('商品匹配--', obj)
				this.storeGoodsInfo.warehouseLocationFromName=obj.warehouseLocationName;
				this.storeGoodsInfo.warehouseLocationFrom=obj.warehouseLocationId;
				this.storeGoodsInfo.goodsStatusFormName=obj.goodsStatusName;
				this.storeGoodsInfo.goodsStatusForm=obj.goodsStatus;
				this.storeGoodsInfo.batchNo=obj.batchNo;
				this.storeGoodsInfo.numOne=obj.num;
				this.storeGoodsInfo.eaNumOne=obj.eaNum;
				this.storeGoodsInfo.pdtName=obj.pdtName;
				this.storeGoodsInfo.pdtId=obj.pdtId;
				this.boxGauge=obj.boxGauge;
				this.storeGoodsInfo.warehouseAreaId=obj.warehouseAreaId;
				this.storeGoodsInfo.storageTime=obj.storageTime;
			},
			getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
			},
			inputInputRight(a){
				if(a=='num'){
					if(this.storeGoodsInfo.num==0){
						this.$message.error('移动数不可以为0');
						return
					}
					if(this.boxGauge){
						this.storeGoodsInfo.eaNum = Number(this.storeGoodsInfo.num) * Number(this.boxGauge)
						// console.log('b.eaNum--', b.eaNum)
					}else{
						this.storeGoodsInfo.eaNum =this.storeGoodsInfo.eaNum
					}
					// console.log('箱规---', this.boxGauge)
					// this.storeGoodsInfo.eaNum = Number(this.storeGoodsInfo.num) * Number(this.boxGauge)
				}
			},
			// 提交
			submit() {
                // let data = this.storeGoodsInfo
                this.addLoading = true;
				let data = {
					pdtId: this.storeGoodsInfo.pdtId,
					warehouseId: this.storeGoodsInfo.warehouseId,
					customerId: this.storeGoodsInfo.customerId,
					goodsStatusTo: this.storeGoodsInfo.goodsStatusTo,
					warehouseLocationTo: this.storeGoodsInfo.warehouseLocationTo,
					num: this.storeGoodsInfo.num,
					eaNum: this.storeGoodsInfo.eaNum,
					memo: this.storeGoodsInfo.memo,

					warehouseAreaId: this.storeGoodsInfo.warehouseAreaId,
					batchNo: this.storeGoodsInfo.batchNo,
					goodsStatusForm: this.storeGoodsInfo.goodsStatusForm,
					warehouseLocationFrom: this.storeGoodsInfo.warehouseLocationFrom,
					storageTime: this.storeGoodsInfo.storageTime,
				}
				// console.log(data)
				this.$api.addGoodsTransStatusInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
               let url='/warehouseBill/addorder'
							
				this.$api.findByManageUserIdManageFunction().then((res) => {
					if (res.state == 'success') {
						res.data.forEach(item => {
						    item.manageFunctionList.forEach(i => {
						        if (i.routePath === url) {
						          this.next(i,'2',e)
						        }
						    });
						});
					}
				})

			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					warehouseId: this.warehouseId,
					warehouseAreaCode: this.storeGoodsInfo.warehouseAreaCode,
					warehouseAreaName: this.storeGoodsInfo.warehouseAreaName,
                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,
                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseDistrictInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			toDelete(e){
				var str = "此操作将删除移库单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.delWmsTransOrdertInfoByID(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将移库中, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.wmsTransOrdertUpdateStatus(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将关单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.wmsTransOrdertUpdateStatus(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            WarehouseLis(){
                this.$api.getWarehouseListNoParameter({
					status: 1
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
            },
		},
		created() {
			this.findPmsUnit()
			this.WarehouseLis()
			this.getStateOfGoodsListI();
            this.$api.findcusomer(this.$encrypt({})).then(res => { //客户
				res.data=JSON.parse(this.$decrypt(res.data)).data
				this.userList = res.data
			})
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
</style>
